module.exports = __webpack_public_path__ + "img/20210512.d3b4696a.png";